import { ConstraintFragment } from '@occc/graphql';
import { routeCreator as audienceRouteCreator } from '@occc-app/routes/Audience/utils';
import { useMemo } from 'react';
import { useGetAudienceSelectItemsByUuids } from '@occc-app/dataAccessLayer/audience/useGetAudienceSelectItemsByUuids';
import { useChainId } from '@occc-app/Chain/hooks';
import { getConstraintsByType } from '../constraints-section.utils';
import { ChipList } from '../../../components';

export const AudienceConstraint = ({ constraints }: { constraints: ConstraintFragment[] }) => {
  const chainId = useChainId();
  const cst = getConstraintsByType('ConstraintInAudience', constraints);
  const audienceIds = cst.map((c) => c.audienceId);

  const { loading, error, data } = useGetAudienceSelectItemsByUuids({
    uuids: audienceIds,
    chainId: chainId,
    skip: audienceIds.length === 0,
  });

  const audienceChips = useMemo(() => {
    if (!data) return [];
    return data.map((a) => ({
      label: a.name,
      href: audienceRouteCreator.details(a.uuid),
    }));
  }, [data]);

  if (error) {
    return null;
  }

  return <ChipList isLoading={loading} label='Target Audience' items={audienceChips} />;
};
